<template>
    <div class="WPaginate">
        <paginate
            v-model="page"
            :pageCount="pages"
            :pageRange="pageRange"
            :prevText="prevText"
            :nextText="nextText"
            :containerClass="containerClass"
            :hidePrevNext="hidePrevNext"
        >
            >
            <template #breakViewContent>
                <span>...</span>
                <slot name="breakViewContent" />
            </template>
        </paginate>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
// More info: https://github.com/lokyoung/vuejs-paginate#readme
export default {
    name: 'WPaginate',
    props: {
        selected: VueTypes.number.def(1),
        pages: VueTypes.number,
        pageRange: VueTypes.number.def(3),
        prevText: VueTypes.string.def('<i class="icon-chevron-left" />'),
        nextText: VueTypes.string.def('<i class="icon-chevron-right" />'),
        containerClass: VueTypes.string,
        hidePrevNext: VueTypes.bool.def(false),
    },
    computed: {
        page: {
            get () {
                return this.selected
            },
            set (value) {
                this.$emit('onChange', value)
            },
        },
    },
}
</script>

<style scoped lang="scss">
.WPaginate {
    ul {
        display: flex;
        align-items: center;
        list-style: none;
        padding: 0;
        margin: 0;
    }
    &::v-deep li {
        margin: 6px;
    }
    &::v-deep li a {
        outline: none;
    }
	&::v-deep li:not(.disabled):not(:first-child):not(:last-child) a {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 20px;
        height: 20px;
        margin-top: -1px;
        border-radius: $border-radius;
        color: $accent-blue;
        background-color: rgba($accent-blue, .15);
        font-size: 16px;
        outline: none;
        user-select: none;

        &:before {
            content: '';
            height: 2px;
        }
    }
	&::v-deep i {
        font-size: 18px;
        color: $accent-blue
    }
    &::v-deep li.active a {
        color: $white !important;
        background-color: $accent-blue !important;
    }
}
</style>
